import { render } from "./Project-2.vue?vue&type=template&id=fa79a198"
import script from "./Project-2.vue?vue&type=script&lang=js"
export * from "./Project-2.vue?vue&type=script&lang=js"
script.render = render

export default script